import { BrowserRouter, Routes, Route, Navigate } from "react-router-dom";
import "@/App.css";
import "@/index.css";
import { Toaster } from "sonner";
import Login from "@/pages/Login";
import AdminDashboard from "@/pages/AdminDashboard";
import ClientManage from "@/pages/ClientManage";
import ClientDashboard from "@/pages/ClientDashboard";
import ClientFlashReport from "@/pages/ClientFlashReport";
import ManagementBoardPack from "@/pages/ManagementBoardPack";
import FlashEmailDraft from "@/pages/FlashEmailDraft";
import { useAdmin } from "@/lib/auth";

function RequireAdmin({ children }) {
  const me = useAdmin();
  if (me === null) return <div className="min-h-screen bg-[#F5F5F5]" data-testid="auth-checking" />;
  if (me === false) return <Navigate to="/login" replace />;
  return children;
}

function Root() {
  const me = useAdmin();
  if (me === null) return null;
  return <Navigate to={me ? "/admin" : "/login"} replace />;
}

export default function App() {
  return (
    <BrowserRouter>
      <Toaster position="top-center" richColors />
      <Routes>
        <Route path="/" element={<Root />} />
        <Route path="/login" element={<Login />} />
        <Route path="/admin" element={<RequireAdmin><AdminDashboard /></RequireAdmin>} />
        <Route path="/admin/clients/:id" element={<RequireAdmin><ClientManage /></RequireAdmin>} />
        <Route path="/admin/clients/:id/management" element={<RequireAdmin><ManagementBoardPack /></RequireAdmin>} />
        <Route path="/admin/email-drafts/:draftId" element={<RequireAdmin><FlashEmailDraft /></RequireAdmin>} />
        {/* Legacy route aliases — Firm Settings, Report Templates and
            standalone Connections pages have all been removed. Redirect any
            bookmarks back to the unified Client Directory. */}
        <Route path="/admin/settings" element={<Navigate to="/admin" replace />} />
        <Route path="/admin/connections" element={<Navigate to="/admin" replace />} />
        <Route path="/admin/templates" element={<Navigate to="/admin" replace />} />
        <Route path="/admin/clients/:id/report-builder" element={<Navigate to="/admin" replace />} />
        <Route path="/c/:token" element={<ClientFlashReport />} />
        <Route path="/flash/:token" element={<ClientFlashReport />} />
      </Routes>
    </BrowserRouter>
  );
}
